import { TouchableOpacity, View, Text } from 'react-native'
import { mesaColorNames, typography } from '@/src/common/theme'
import { DesignSystem } from '@/src/design-system'
import { ChevronRight } from '@/src/assets/icons/ChevronRight'
import { router } from 'expo-router'
import * as E2E from '../e2e'
import { useActiveApplication } from '../hooks/useActiveApplication'
import { ApplicationStatusRoutes } from '../navigation'

export const ApplicationStatusBanner = () => {
  const { status, activeApplicationStatus } = useActiveApplication()

  if (status === 'LOADING' || status === 'ERROR') {
    return <></>
  }

  const generateCardApplicationBannerContent = (
    status: NonNullable<typeof activeApplicationStatus>,
  ) => {
    switch (status) {
      case 'DOCUMENT_UPLOAD':
        return {
          text: 'Additional documentation verification is required to process your application.',
          navigateTo: () => {
            router.push(ApplicationStatusRoutes['DOCUMENT_UPLOAD'].entryRoute.route)
          },
        }
      case 'MANUAL_REVIEW_GENERIC':
        return {
          text: 'Your application is currently under review. Expect an update within 1-2 business days.',
        }
      case 'FROZEN_CREDIT':
        return {
          text: 'Your credit is frozen. Please unfreeze directly with the bureau then return here to proceed.',
          navigateTo: () => {
            router.push(ApplicationStatusRoutes['FROZEN_CREDIT'].entryRoute.route)
          },
        }
      default:
        return {}
    }
  }

  const cardApplicationBannerContent = generateCardApplicationBannerContent(activeApplicationStatus)

  if (!cardApplicationBannerContent.text) {
    return <></>
  }

  return (
    <TouchableOpacity
      style={{ width: '100%' }}
      onPress={() => {
        if (cardApplicationBannerContent.navigateTo) {
          cardApplicationBannerContent.navigateTo()
        }
      }}
      testID={E2E.Config.Ids.Press.CardApplicationStatusBanner}
      disabled={cardApplicationBannerContent.navigateTo === undefined}
    >
      <DesignSystem.Card
        style={{
          borderColor: mesaColorNames['Mesa Primary Scale/400 - Brand #00DFC9'],
          borderWidth: 1,
          backgroundColor: 'white',
          padding: 16,
        }}
      >
        <View
          style={{
            flexDirection: 'row',
          }}
        >
          <View style={{ flex: 1 }}>
            <View>
              <Text
                style={[
                  typography['Base Bold'],
                  { color: mesaColorNames['Mesa - Brand/Blackish #222222'] },
                ]}
                numberOfLines={1}
              >
                Mesa Card Application Status
              </Text>
            </View>

            <Text
              style={[typography.S, { color: mesaColorNames['Mesa - Brand/Blackish #222222'] }]}
            >
              {cardApplicationBannerContent.text}
            </Text>
          </View>

          {cardApplicationBannerContent.navigateTo && (
            <View
              style={{
                justifyContent: 'space-evenly',
                marginLeft: 8,
              }}
            >
              <ChevronRight color={mesaColorNames['Mesa - Brand/Blackish #222222']} size={20} />
            </View>
          )}
        </View>
      </DesignSystem.Card>
    </TouchableOpacity>
  )
}
